export const STAGES = [
  { key: 'initial', label: '빌드 · 초기개발', runtime: 'Ansible + PM2', proof: 'initialVerified' },
  { key: 'stabilization', label: '안정화 검증', runtime: 'K3s', proof: 'stabilizationVerified' },
  { key: 'production', label: '운영 배포', runtime: 'Kubernetes', proof: 'productionVerified' },
]
export const SIGNALS = {
  operating: { label: '운영 중', tone: 'good' }, drift: { label: '불일치', tone: 'bad' },
  stopped: { label: '중단', tone: 'bad' }, maintenance: { label: '점검', tone: 'warn' },
  unverified: { label: '확인 불가', tone: 'unknown' }, unset: { label: '미설정', tone: 'unknown' },
}
export function current(value, now = Date.now()) {
  const at = new Date(value || '').getTime()
  return Number.isFinite(at) && Math.abs(now - at) <= 120000
}
export function nodeMetrics(clusters, now = Date.now()) {
  const nodes = clusters.flatMap(c => (c.snapshot?.nodes || []).map(n => ({ ...n, cluster: c, key: `${c.id}/${n.uid || n.name}` })))
  const available = nodes.filter(n => n.metricAvailable && current(n.metricAt, now))
  const weighted = (used, total) => {
    const valid = available.filter(n => Number.isFinite(n[used]) && n[used] >= 0 && Number.isFinite(n[total]) && n[total] > 0)
    return { value: valid.length ? 100 * valid.reduce((s, n) => s + n[used], 0) / valid.reduce((s, n) => s + n[total], 0) : null, count: valid.length }
  }
  return { nodes, cpu: weighted('cpuMillis', 'cpuAllocatableMillis'), memory: weighted('memoryBytes', 'memoryAllocatableBytes'),
    sampleKey: available.map(n => n.key + ':' + n.metricAt).sort().join('|') }
}
export function lifecycleFlow(data) {
  const runs = [...(data?.runs || [])].sort((a, b) => b.createdAt - a.createdAt)
  const active = runs.find(r => ['running', 'queued'].includes(r.state))
  const commit = active?.sourceCommit || data?.releases?.[0]?.sourceCommit
  const release = data?.releases?.find(r => r.sourceCommit === commit)
  const pipeline = runs.find(r => r.sourceCommit === commit && r.stage === 'pipeline')
  return { commit, release, steps: STAGES.map(stage => {
    const direct = runs.find(r => r.sourceCommit === commit && r.stage === stage.key)
    const step = pipeline?.steps?.find(s => s.stage === stage.key)
    const run = step && (!direct || pipeline.createdAt >= direct.createdAt) ? {...step,createdAt:step.startedAt || pipeline.createdAt} : direct
    // A recorded request or running job is never proof of a completed stage.
    const state = run && ['running', 'queued', 'failed'].includes(run.state) ? run.state : release?.[stage.proof] || run?.state==='verified' ? 'verified' : 'waiting'
    return { ...stage, state, run }
  }) }
}
// Runtime observations and operator intent remain distinct. A missing intent
// is not an unconfigured deployment when the registered target is running.
export function serviceSignals(board,telemetry,failed=false,now=Date.now()) {
  const services=board?.services || []
  if(failed || !current(telemetry?.observedAt,now))return services
  return services.map(service=>({...service,environments:['production','development'].map(environment=>{
    const previous=service.environments?.find(e=>e.environment===environment)||{environment}
    const row=telemetry.resources?.find(r=>r.kind==='service'&&r.serviceId===service.serviceId&&r.environment===environment)
    if(!row)return previous
    const target=row.target||previous.target
    let status='unverified'
    if(target?.startsWith('unconfigured:'))status='unset'
    else if(row.collection==='collected' && current(row.at*1000,now)) {
      const running=['running','Running','online','active','ready','healthy'].includes(row.state)
      const stopped=['stopped','errored','inactive','failed','degraded','not-ready','unavailable'].includes(row.state)
      if(running)status=previous.desiredState&&previous.desiredState!=='running'?'drift':'operating'
      else if(stopped)status=previous.desiredState==='running'?'drift':previous.desiredState||'stopped'
    }
    return {...previous,target,status}
  })}))
}
export function appendSample(history, sample) {
  if (sample.sampleKey && history.at(-1)?.sampleKey === sample.sampleKey) return history
  if (!sample.sampleKey && history.at(-1)?.sampleKey === '') return history
  return [...history, sample].slice(-20)
}
